import React, { useEffect, useState } from "react";
import "./QuickLink.css";
import { FiPlus } from "react-icons/fi";
import { FaGlobe } from "react-icons/fa";
// import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { Modal, Button, Form, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import axios from "axios";
import { format } from "date-fns";
import ic_globe from "../../images/ic_globe_bg.svg";

const QuickLink = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    // console.log('storedUserDataArray::',storedUserDataArray)
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [isCreateTaskModalOpen, setCreateTaskModalOpen] = useState(false);

  const [loggedUserLinks, setLoggedUserLinks] = useState("");

  const [loggedUserId, setLoggedUserId] = useState("");

  const [link, setLink] = useState("");

  const [description, setDescription] = useState("");

  const [saveLoader, setSaveLoader] = useState(false);

  const [getLinkLoader, setGetLinkLoader] = useState(false);

  const [base_url, setBaseUrl] = useState(`${base_url_from_axios_config}/`);

  const openCreateTaskModal = () => {
    setCreateTaskModalOpen(true);
  };

  const closeCreateTaskModal = () => {
    setCreateTaskModalOpen(false);
  };

  const getFirstLetter = (linkFromParent) => {
    // console.log('linkFromParent:',linkFromParent)
    let pathArray = linkFromParent.split("/");
    // console.log('pathArray:',pathArray)
    let host = pathArray[2];
    // console.log('host:',host)
    // console.log('host[0]:',host[0])
    return host[0];
  };

  const fetchAllUserLinks = async () => {
    setGetLinkLoader(true);
    try {
      const response = await axios.get(
        `${base_url}api/CRMQuickLinkList/${companyCode}/ALL/${loggedUserId}/-`,
      );

      if (response.status === 200 && response.data) {
        // console.log("response.data", response.data);

        let newArray = response.data
          .filter((item) => item.Link && item.Description) // Skip blank links
          .map((item) => {
            const h = Math.floor(Math.random() * 360);
            const color_code = `hsl(${h}deg, 100%, 90%)`;
            // const first_letter = getFirstLetter(item.Link);
            // const first_letter = getFirstLetter(item.Description);
            return {
              ...item,
              // firstLetter: first_letter?.toUpperCase(),
              colorCode: color_code,
            };
          });

        // console.log("new array QuickLink", newArray);
        setLoggedUserLinks(newArray);
      } else {
        // console.log("something went wrong with quick link");
      }

      setGetLinkLoader(false);
    } catch (error) {
      // console.log("fetchAllUserLinksErr", error);
      setGetLinkLoader(false);
    }
  };

  const handleCreateTask = async () => {
    const today = new Date();
    const formattedDate = format(today, "dd-MMM-yyyy HH:mm:ss");

    setSaveLoader(true);

    try {
      const data = [
        {
          cmpcode: `${companyCode}`,
          mode: "ENTRY",
          id: "0",
          link: link,
          description: description,
          user_id: loggedUserId,
          created_on: formattedDate,
          status: "",
        },
      ];

      const postBody = JSON.stringify(data);

      const response = await axios.post(
        `${base_url}api/CRMQuickLink`,
        postBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        toast.success("Link Saved!");
        setSaveLoader(false);

        fetchAllUserLinks();

        setLink("");
        setDescription("");

        closeCreateTaskModal();
      }
    } catch (error) {
      // console.log("handleCreateTaskErr", handleCreateTask);
      toast.error("Error Saving Link!");
      setSaveLoader(false);
    }
    // Add logic for handling task creation
    // closeCreateTaskModal();
  };

  useEffect(() => {
    // fetchAllUserLinks()

    const storedLoginUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];

    if (storedLoginUserDataArray.length > 0) {
      setLoggedUserId(storedLoginUserDataArray[0].EMPID);
      // setFilterId(storedLoginUserDataArray[0].EMPID)
    }
  }, []);

  useEffect(() => {
    if (loggedUserId && base_url) {
      fetchAllUserLinks();
    }
  }, [loggedUserId, base_url]);

  return (
    <div className="QLWrapper">
      <div className="QLCont">
        <div className="QLHead  flex items-center justify-between">
          <div
            style={{ fontSize: "14px", color: "#000000", fontWeight: "bold" }}
          >
            Quick Links
          </div>
          {/* <div className="QLAddCont " onClick={openCreateTaskModal}>
            <div>
              <FiPlus />
            </div>
            <div className="QLAddText">Add link</div>
          </div> */}

          <button
            onClick={openCreateTaskModal}
            className="flex items-center gap-2 pl-1 pr-2 py-0.5  text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all duration-200"
          >
            <FiPlus className="text-md" />
            <span className="font-medium">Add</span>
          </button>
        </div>
        {/* create addLink popup */}
        <Modal
          show={isCreateTaskModalOpen}
          onHide={closeCreateTaskModal}
          centered
        >
          <Modal.Header closeButton>
            <span>Add Link</span>
          </Modal.Header>
          <Modal.Body>
            {/* Task Creation Form */}
            <form className="d-flex flex-column justify-content-center align-items-center bg-white">
              <div className="form-group w-100  mb-2">
                <label>Link</label>
                <input
                  type="text"
                  className="form-control w-100"
                  placeholder="Enter Link"
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                />
              </div>

              <div className="form-group w-100  mb-2">
                <label>Description</label>
                <input
                  type="text"
                  className="form-control w-100"
                  placeholder="Enter Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant='secondary' onClick={closeCreateTaskModal}>
                            Close
                        </Button> */}
            <Button
              className="salseDoodButtonColor "
              onClick={handleCreateTask}
              disabled={saveLoader}
            >
              Add Link
            </Button>
          </Modal.Footer>
        </Modal>
        {/* create addLink popup */}
        <div className="QLAddedLinkCont">
          {!loggedUserLinks && (
            <div
              style={{
                textAlign: "center",
                color: "red",
              }}
            >
              No Data Available
            </div>
          )}

          <div className="request_grid">
            {loggedUserLinks &&
              loggedUserLinks.length > 0 &&
              loggedUserLinks.map((item, index) => (
                <div className="request_grid_item shadow-sm" key={index}>
                  <div
                    style={{
                      backgroundColor: item.colorCode,
                      fontSize: "20px",
                      padding: "20px",
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <img
                      style={{
                        position: "absolute",
                        top: "0px",
                        left: "0px",
                        width: "50px",
                        opacity: "0.8",
                        zIndex: "1",
                      }}
                      src={ic_globe}
                    />
                    <span
                      style={{
                        position: "absolute",
                        top: "20%",
                        left: "35%",
                        zIndex: "2",
                      }}
                    >
                      {item.firstLetter}
                    </span>
                  </div>

                  <a
                    // className="QLLinkText text-xs"
                    className="w-15 text-xs"
                    href={item.Link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.Link}
                  </a>

                  <p style={{ fontSize: "14px", color: "#808080" }}>
                    {item.Description}
                  </p>

                  {/* 
                                <div>
                                    <a className='QLLinkText' href={item.Link}>{item.Link}</a>

                                    <span>{item.Description}</span>
                                </div> */}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickLink;
